import { render, staticRenderFns } from "./JerarquiaMedalla.vue?vue&type=template&id=023e6fd3&"
import script from "./JerarquiaMedalla.vue?vue&type=script&lang=js&"
export * from "./JerarquiaMedalla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})
